import { Collection } from 'firestorter';

import Collections from '../../utils/collections';
import BaseDocument from '../../Model/BaseDocument';
import callRemote from '../../utils/remote';

const OnHoldWorkoutReviewState = {
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED',
  SKIPPED: 'SKIPPED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
};

class OnHoldWorkoutReview extends BaseDocument {
  constructor(id, opts) {
    super(`${Collections.ON_HOLD_WORKOUT_REVIEW}/${id}`, opts);
  }

  get coach() {
    return this.data.coach;
  }

  get user() {
    return this.data.user;
  }

  get state() {
    return this.data.state;
  }

  get scheduledAssignmentId() {
    return this.data.scheduledAssignmentId;
  }

  get programProgressionRequestId() {
    return this.data.programProgressionRequestId;
  }

  get conflicts() {
    return this.data.conflicts || [];
  }

  get exerciseIds() {
    return this.data.exerciseIds || [];
  }

  get skippedExerciseIds() {
    return this.data.skippedExerciseIds || [];
  }

  get isBlocked() {
    return this.data.isBlocked === true;
  }

  get isBlockedBy() {
    return this.data.isBlockedBy || [];
  }

  get isBlockedByLabels() {
    return this.data.isBlockedByLabels || {};
  }

  get displayLabel() {
    return this.data.displayLabel || '';
  }

  get occurrenceCount() {
    return this.data.occurrenceCount || 0;
  }

  get createdAt() {
    return this.data.createdAt?.toDate();
  }

  static getPendingForCoach(coachId) {
    return new Collection(Collections.ON_HOLD_WORKOUT_REVIEW, {
      createDocument: ({ id }, opts) => new OnHoldWorkoutReview(id, { ...opts, disableObserverRefCount: true }),
      query: (ref) => ref
        .where('coach', '==', coachId)
        .where('state', '==', OnHoldWorkoutReviewState.PENDING)
        .orderBy('createdAt', 'asc'),
    });
  }

  resolve = async (idToken, overrides = []) => {
    const body = { onHoldId: this.id };
    if (overrides.length > 0) body.overrides = overrides;
    const response = await callRemote(idToken, 'resolveOnHoldWorkoutBatch', body);
    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({}));
      throw new Error(errorBody.error || `Resolve failed with status ${response.status}`);
    }
    return response.json();
  };
}

export { OnHoldWorkoutReviewState };
export default OnHoldWorkoutReview;
